import { getPolls, pollReset, resetPollDeleteStatus, setViewResponsesModal } from 'features/polls/pollSlice'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'
import PollItem from './PollItem' 
import { MobilePageTitle } from 'components/main.styled'

import { NoItemsContainer } from 'components/main.styled'
import { MdOutlinePoll } from "react-icons/md";
import Modal from '@mui/material/Modal'; 
import ConfirmModal from 'components/modals/ConfirmModal'   
import { setConfirmModalData, setViewConfirmModal } from 'features/modal/modalSlice'
import PollResponseModal from './PollResponsesModal'
import SpinnerSmall from 'components/SpinnerSmall'
import { useTranslation } from 'react-i18next'


export default function PollFeed() {
  const { t: translate } = useTranslation()
    const dispatch = useDispatch() 
    const { user } = useSelector((state) => state.auth)
    const { polls, isPollsSuccess, isPollsLoading, hasNextPage, pageNumber, isPollDeleteSuccess, isPollDeleteLoading, viewResponsesModal } = useSelector((state) => state.poll)
    const { profileChurch } = useSelector((state) => state.profileChurch)
    const { viewConfirmModal, confirmModalData } = useSelector((state) => state.modal)
 
    useEffect(() => {
        if(isPollDeleteSuccess){
            dispatch(setConfirmModalData({}))
            dispatch(setViewConfirmModal(false))
            dispatch(resetPollDeleteStatus())
        }
    }, [isPollDeleteSuccess, dispatch])

    useEffect(() => {
        if(profileChurch){
            dispatch(getPolls({
                id: profileChurch._id
            }))             
        } 
    }, []) 


    const handleLoadMore = () => {
        if(hasNextPage && !isPollsLoading){
            dispatch(getPolls({
                id: profileChurch._id,
                pageNumber: pageNumber + 1,
                //sort by date
                //sort by number of votes
            }))
        }
    }

    useEffect(() => {
        return () => {
          dispatch(pollReset())
        }
      }, [])


  return (
    <PollFeedContainer> 

        {
            isPollsLoading ? 
            (
                <NoItemsContainer>
                    <SpinnerSmall border='#797979' />
                </NoItemsContainer>
            )
            : (isPollsSuccess && polls.length > 0) ?
            (
                polls.map((poll, index) => (
                    <PollItem 
                        key={poll._id} 
                        index={index} 
                        data={poll} 
                        />
                    )
                )
            )
            : isPollsSuccess && polls.length === 0 &&
            (
                <NoItemsContainer>
                    <MdOutlinePoll />
                    <div>
                        {
                            translate("web:polls.noPolls")
                        }
                    </div>  
                </NoItemsContainer>
            )
        }







        {
            hasNextPage && (
                <LoadPollsButton onClick={handleLoadMore}>{translate('polls:actions.loadMore')}</LoadPollsButton>
            )
        }


        <Modal
                open={viewConfirmModal}
                onClose={() => dispatch(setViewConfirmModal(false))}
                aria-labelledby="modal-modal-title"
                >
                <ModalWrapper1>
                    <ConfirmModal 
                        text={confirmModalData.text} 
                        handler={confirmModalData.handler} 
                        confirmBtnBackgroundHover={confirmModalData.confirmBtnBackgroundHover}
                        extraInfo={confirmModalData.extraInfo}
                        conditionToCloseModal={isPollDeleteSuccess}
                        loadingState={isPollDeleteLoading}
                        />                
                </ModalWrapper1> 
        </Modal>

        <Modal
            open={viewResponsesModal.viewModal}
            onClose={() => dispatch(setViewResponsesModal({
                id: '',
                viewModal: false
            }))}
            aria-labelledby="modal-modal-title"
            >
            <ModalWrapper1>     
                <PollResponseModal />
            </ModalWrapper1> 
        </Modal>

    </PollFeedContainer>
  )
}

const ModalWrapper1 = styled.div`   
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`

const PollFeedContainer = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    align-items: center;
    flex-wrap: wrap;
    margin-top: 25px;
    @media (max-width: 768px) {
        padding: 5px;
        width: 100%;
        flex-direction: column;
        margin-top: 0px;
    }
`

const LoadPollsButton = styled.div`
    padding: 5px 20px;
    background-color: white;
    border: 1px solid grey;
    outline: none;
    cursor: pointer;
    color: #414141;
    border-radius: 5px;
    margin-bottom: 20px;
    &:hover{
        background-color: #c3c3c3;
    }

`
